import { CircularProgress, TextField } from '@mui/material'
import { AutocompleteRenderInputParams } from '@mui/material/Autocomplete'

interface Props {
  loading: boolean
  params: AutocompleteRenderInputParams
  label?: string
  variant?: 'filled' | 'outlined' | 'standard'
}

export const RenderInputWithLoader = ({
  params,
  loading,
  label = '',
  variant = 'outlined',
}: Props) => (
  <TextField
    {...params}
    variant={variant}
    label={label}
    InputProps={{
      ...params.InputProps,
      endAdornment: (
        <>
          {loading && <CircularProgress color="primary" size={20} />}
          {params.InputProps.endAdornment}
        </>
      ),
    }}
  />
)
